import LightImage from "@/views/tools/player/certificate/templates/LightImage.vue";
import LightWaves from "@/views/tools/player/certificate/templates/LightWaves.vue";
import LightStripes from "@/views/tools/player/certificate/templates/LightStripes.vue";
import DarkStripes from "@/views/tools/player/certificate/templates/DarkStripes.vue";
import DarkDots from "@/views/tools/player/certificate/templates/DarkDots.vue";
import LightWavesBadge from "@/views/tools/player/certificate/templates/LightWavesBadge.vue";
import LightStripesBadge from "@/views/tools/player/certificate/templates/LightStripesBadge.vue";
import LightImageBadge from "@/views/tools/player/certificate/templates/LightImageBadge.vue";
import DarkStripesBadge from "@/views/tools/player/certificate/templates/DarkStripesBadge.vue";
import DarkDotsBadge from "@/views/tools/player/certificate/templates/DarkDotsBadge.vue";
import CustomTemplate from "@/views/tools/player/certificate/templates/CustomTemplate.vue";
import CustomTemplateBadge from "@/views/tools/player/certificate/templates/CustomTemplateBadge.vue";
import { t } from "@/i18n";
import { computed } from "vue";

const DEFAULT_TEMPLATE_NAME_VALUE = "light-image";

// must be computed() to accept language change. For t("...")!
const PLAYER_CERTIFICATE_TEMPLATES = computed(() => [
    {
        value: DEFAULT_TEMPLATE_NAME_VALUE,
        label: t("player.templates.light-image"),
        component: LightImage,
        badge: LightImageBadge,
        fields: ["courseName", "courseImage"],
    },
    {
        value: "light-waves",
        label: t("player.templates.light-waves"),
        component: LightWaves,
        badge: LightWavesBadge,
        fields: ["courseName", "courseDescription", "color"],
    },
    {
        value: "light-stripes",
        label: t("player.templates.light-stripes"),
        component: LightStripes,
        badge: LightStripesBadge,
        fields: ["courseName", "courseDescription", "color"],
    },
    {
        value: "dark-stripes",
        label: t("player.templates.dark-stripes"),
        component: DarkStripes,
        badge: DarkStripesBadge,
        fields: ["courseName", "courseDescription", "color"],
    },
    {
        value: "dark-dots",
        label: t("player.templates.dark-dots"),
        component: DarkDots,
        badge: DarkDotsBadge,
        fields: ["courseName", "courseDescription", "color"],
    },
    {
        value: "custom",
        label: t("player.templates.custom"),
        component: CustomTemplate,
        badge: CustomTemplateBadge,
        fields: ["courseName", "courseDescription", "courseImage", "backgroundImage", "textColor"],
    },
]);

function findTemplateByValue(value) {
    return PLAYER_CERTIFICATE_TEMPLATES.value.find((t) => t.value === value);
}

export const certificateTemplatesService = {
    getDefaultProgressThreshold() {
        return 80;
    },
    /**
     * @return {'light-image'}
     * */
    getDefaultName() {
        return DEFAULT_TEMPLATE_NAME_VALUE;
    },
    getDefaultCertTemplate() {
        return findTemplateByValue(DEFAULT_TEMPLATE_NAME_VALUE);
    },
    getAllValues() {
        return PLAYER_CERTIFICATE_TEMPLATES.value;
    },
    /**
     * this will fall back to DEFAULT_CERT_TEMPLATE if not found!
     *
     * @param value {'light-image' | 'light-waves' | 'light-stripes' | 'dark-stripes' | 'dark-dots'}
     * */
    getPlayerCertTemplate(value) {
        return findTemplateByValue(value) || DEFAULT_CERT_TEMPLATE;
    },
};

const DEFAULT_CERT_TEMPLATE = certificateTemplatesService.getDefaultCertTemplate();
